import { render, staticRenderFns } from "./bindForm.vue?vue&type=template&id=d4dd5624"
import script from "./bindForm.vue?vue&type=script&lang=js"
export * from "./bindForm.vue?vue&type=script&lang=js"
import style0 from "./bindForm.vue?vue&type=style&index=0&id=d4dd5624&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports